import { AfterViewInit, Component, ElementRef, Input, SimpleChanges, ViewChild, } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { Input as RouterInput } from '@angular/core';
import { PageService } from 'app/services/page.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { SelectEvent } from '@progress/kendo-angular-charts';
import { DrakeCustomComponentComponent } from 'app/drake-components/drake-custom-component/drake-custom-component.component';
import { GridService } from 'app/services/grid.service';
import { DrakeSharedService } from 'app/services/drake-shared.service';
import { TranslocoPipe } from '@ngneat/transloco';
import { HttpClient } from '@angular/common/http';
import { drawDOM, exportPDF } from '@progress/kendo-drawing';
import { saveAs } from '@progress/kendo-file-saver';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import {
  SVGIcon,
  downloadIcon
} from "@progress/kendo-svg-icons";




@Component({
  selector: 'app-drake-scope-form-print',
  templateUrl: './drake-scope-form-print.component.html',
  styleUrls: ['./drake-scope-form-print.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    InputsModule,
    TabStripModule,
    DrakeCustomComponentComponent,
    TranslocoPipe,
    ButtonsModule
  ]
})
export class DrakeScopeFormPrintComponent implements AfterViewInit {
  @ViewChild('printSection', { static: true }) printSection: ElementRef;
  @RouterInput() scope!: string;
  @RouterInput() id!: string;
  @Input() readonly: boolean = false;

  public userId: string;
  public downloadIcon: SVGIcon = downloadIcon;

  public pageData: any;
  public baseData: any = {};
  visibleSections: { [key: string]: boolean } = {};
  public firstTimeSection: boolean = true;



  constructor(private activatedRoute: ActivatedRoute, pageService: PageService, private drakeShared: DrakeSharedService) {
    drakeShared.currentBaseData = this.baseData;
    //drakeShared.currentBaseData = this.baseData;
    this.activatedRoute.params.subscribe(params => {
      pageService.getPageByUrl(`d/${params?.['scope']}/f/*`).subscribe((result: any) => {
        this.pageData = result;
        drakeShared.currentPageData = result;
        this.initializeVisibleSections();

      });
      console.log("Base data, Page data", this.baseData, this.pageData);
    })

  }
  ngAfterViewInit(): void {
    this.initializeVisibleSections();
  }

  public onTabSelect(e: SelectEvent): void {
    console.log(e);
  }


  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      this.userId = params['id'];
      this.loadProfileData();
    });
    if (this.pageData && this.pageData.pageTabs) {
      this.pageData.pageTabs.forEach(tab => {
        this.visibleSections[tab.tabTitle] = true;
      });
    }
    this.drakeShared.addBreadcrumbUrl();
    
  }

  initializeVisibleSections(): void {
    if (this.pageData && this.pageData.pageTabs) {
      this.pageData.pageTabs.forEach(tab => {
        this.visibleSections[tab.tabTitle] = true;
      });
    }
  }

  toggleSection(section: string): void {
    this.visibleSections[section] = !this.visibleSections[section];
  }

  isSectionVisible(section: string): boolean {
    return this.visibleSections[section];
  }

  loadProfileData(): void {

  }

  public printPDF(): void {
    const element = this.printSection.nativeElement;
    drawDOM(element, {
      forcePageBreak: ".page-break",
      scale: 0.6,
      paperSize: "A4",
      margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" }
    })
      .then(function (group) {
        return exportPDF(group, {
          paperSize: "A4",
          margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
          landscape: false
        });
      })
      .then(function (data) {
        saveAs(data, 'Stampa_' + 'my_scope' + "_" + new Date().toISOString().slice(0, 10) + ".pdf");
      })
      .catch(function (error) {
        console.error('Error generating PDF:', error);
      });
  }
}
